const lbCountrySelect = angular.module('app.lbCountrySelect', []);

lbCountrySelect.controller('lbCountrySelectCtrl', require('./lbCountrySelectCtrl'));
lbCountrySelect.component('lbCountrySelect', require('./lbCountrySelect'));

export default lbCountrySelect;



// WEBPACK FOOTER //
// ./src/components/lbCountrySelect/index.js